jQuery(document).ready(function ($) {	
	console.log("scripts.js");
});

jQuery( window ).on( 'elementor/frontend/init', () => {

    /**
     * Get accordion handler.
     * @see https://developers.elementor.com/experiment-optimized-asset-loading/
     * @see https://github.com/elementor/elementor/issues/5533
     **/

    elementorFrontend.elementsHandler.getHandler( 'accordion.default' )
    .then( ( accordionHandler ) => {
        closeElementorAccordion();
    } );


} );

function closeElementorAccordion(){ 
    const accordion = jQuery('.elementor-widget-accordion');
    const accordionTitleText = accordion.find('.elementor-accordion-title').text();
    if (accordionTitleText.includes("disclosure") || accordionTitleText.includes("footnote")) {
        // Text contains either "disclosure" or "footnote"
        console.log("Footnote accordion collapsed");
        jQuery('.elementor-widget-accordion').find('.elementor-active').removeClass('elementor-active');
        jQuery('.elementor-tab-content').css('display', 'none');
    }
}